import type { PcsNetworkMerchantDetail } from './pcs-network-merchant-detail.type.ts';

export interface PcsNetworkMerchantDetailExtension extends PcsNetworkMerchantDetail {}
export class PcsNetworkMerchantDetailExtension {
  get merchantName(): string | null {
    const detail = this.detail ?? {};
    // VISA/STRIPE store a flat `name`; SPADE nests it under `merchant`.
    return detail.name ?? detail.merchant?.name ?? null;
  }
}

const Registration = {
  kind: 'object',
  name: 'pcs-network-merchant-detail',
  features: PcsNetworkMerchantDetailExtension,
};
export default Registration;
